
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("mealplanner/recipeMood",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon class=\"rounded-border\" data-fw-onclick=\"mpunstar\" title=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"status.starredBestMoment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":88},"end":{"line":1,"column":125}}})) != null ? stack1 : "")
    + "\" style=\"color:#FF6C87;border-color:#FF6C87;margin:3px 0px 3px 10px;\" >"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_added_to_favorites",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":196},"end":{"line":1,"column":231}}}))
    + "</icon> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon class=\"rounded-border\" data-fw-onclick=\"mpstar\" title=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.starBestMoment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":309},"end":{"line":1,"column":344}}})) != null ? stack1 : "")
    + "\" style=\"margin:3px 0px 3px 10px;\" >"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_add_to_favorites",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":380},"end":{"line":1,"column":413}}}))
    + "</icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"moodStarShortcut") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":428}}})) != null ? stack1 : "")
    + " ";
},"useData":true});
export default TPL;